import type { ReactNode } from 'react'

import { isNil } from 'ramda'

import { BaseLink } from '../../../atoms/link'

import * as styles from './action.styles'

type Props = {
  children: ReactNode
  href?: string
  to?: string
  onClick?: () => void
}

export const Action = ({ children, href, to, onClick, ...rest }: Props) => {
  const hasLink = !isNil(href) || !isNil(to)
  const isButton = !isNil(onClick)

  if (isButton) {
    return (
      <button css={styles.button} onClick={onClick} {...rest}>
        {children}
      </button>
    )
  }

  if (hasLink) {
    // if banner is used with `to` prop instead of `href` we want to open link in same browser tab
    // otherwise we want to open link in new browser tab with `target='_blank'`
    return (
      <BaseLink
        css={styles.link}
        href={href}
        target={!isNil(href) ? '_blank' : undefined}
        to={to}
        {...rest}
      >
        {children}
      </BaseLink>
    )
  }

  return <>{children}</>
}
